import { dateTimeToDate } from "@/helpers";
import { RucStepGet } from "@/repositories/GeneratedClients";
import { MutationTree } from "vuex";
import * as mutationTypes from "./mutations-types";
import { IRucState } from "./state";

export const mutations: MutationTree<IRucState> = {
    [mutationTypes.SET_RUC_STEPS]: (state, payload: RucStepGet[]) => {
        state.steps = payload.map(step => ({
            ...step,
            endDate: dateTimeToDate(step.endDate),
            startDate: dateTimeToDate(step.startDate),
        })).sort((stepA, stepB) => (stepA.isMidYearReview ? 1 : 0) - (stepB.isMidYearReview ? 1 : 0) || stepA.order - stepB.order);
    },

    [mutationTypes.SET_RUC_STEPS_PROMISE]: (state, payload: Promise<RucStepGet[]> | null) => {
        state.stepsPromise = payload;
    },
};
